module.exports = __webpack_public_path__ + "img/rifle.9ad10899.webp";